import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  display: grid;
  width: 100%;
  align-items: center;
  padding: 16px;
  background-color: ${COLORS.WHITE};
  color: ${COLORS.BLACK};
`;
const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
  padding-bottom: 33px;
`;
const Heading = styled.div`
  h2 {
    display: flex;
    justify-content: space-between;
    text-transform: uppercase;
    text-align: center;
    padding: 28px 0;
    margin: 0;
    color: ${COLORS.BLACK};
    font-size: 28px;
    @media (max-width: 790px) {
      justify-content: center;
      flex-direction: column;
      font-size: 26px;
    }
  }
  span {
    font-size: 21px;
    color: #000;
    @media (max-width: 790px) {
      font-size: 14px;
      margin-top: 8px;
    }
  }
`;
const Separator = styled.div`
  display: block;
  width: 50px;
  height: 3px;
  background: #272742;
  margin: 0 auto;
  position: relative;
`;
const Steps = styled.div`
  display: grid;
  grid-gap: 30px;
  margin: 32px 0 0;
  > div {
    display: grid;
    justify-items: center;
    align-items: end;
    text-align: center;
    box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #fff;
    border-radius: 10px;
    h1 {
      align-self: start;
      color: ${COLORS.BLACK};
      font-size: 20px;
      margin-bottom: 20px;
      margin-top: 0;
      line-height: 30px;
    }
    img {
      margin: 0 auto;
      max-height: 150px;
      align-self: start;
      max-width: 100%;
      margin: 20px 0 25px 0;
    }
    p {
      margin: 0;
      margin-bottom: 20px;
      color: ${COLORS.BLACK};
      font-size: 14.4px;
      line-height: 1.5;
    }
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    > div {
      padding: 14px;
      font-size: 0.9em;
    }
  }
`;

export { Container, Wrapper, Heading, Separator, Steps };
